import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  fetchEnrichedFarmCategories,
  updateSelectedConfigurationTab,
} from "redux/operations";
import type { RootState } from "redux/reducers";
import toggleUtils from "shared/toggleUtils";
import userUtils from "shared/userUtils";
import { obtemPastosFazenda } from "../../manejo/redux/actions/pastoActions";
import {
  ConfigurationItemsVisibility,
  FeaturesVisibility,
} from "../configurations.types";
import ConfigurationsContent from "./configurationsContent";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type FarmConfigurationsContainerProps = StateProps & DispatchProps;

function ConfigurationsContainer({
  fetchFarmCategories,
  fetchFarmPastures,
  selectedFarmId,
  onConfigurationTabChange,
  toggles,
  selectedClient,
}: FarmConfigurationsContainerProps) {
  useEffect(() => {
    fetchFarmCategories();
    fetchFarmPastures(selectedFarmId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFarmId]);

  const featuresVisibility: FeaturesVisibility = {
    showConsumptionClosure: toggleUtils.isConsumptionClosureActive(
      toggles,
      selectedClient?.TipoCliente
    ),
    showCreepFeeding: toggleUtils.isCreepActive(toggles),
    showDeathsAndBirths: toggleUtils.isDeathsAndBirthsActive(toggles),
    showHerdEvolutionAndNutritionPlan: userUtils.isInternalUser(),
    showDrum: toggleUtils.isDrumCollectionActive(toggles),
  };

  const itemsVisibility: ConfigurationItemsVisibility = {
    showCauseOfDeath: toggleUtils.isCauseOfDeathRegistrationActive(toggles),
    showFormulationRegistration:
      toggleUtils.isFormulationRegistrationActive(toggles),
    showHerdEvolutionAndNutritionPlan: userUtils.isInternalUser(),
    showLotGoal: toggleUtils.isLotGoalRegistrationActive(toggles),
    showRainHistory: toggleUtils.isRainActive(toggles),
    showScoreAdjustment: toggleUtils.isScoreAdjustmentActive(toggles),
    showWeightGain: toggleUtils.isWeightGainRegistrationActive(toggles),
  };

  return (
    <ConfigurationsContent
      featuresVisibility={featuresVisibility}
      itemsVisibility={itemsVisibility}
      onSelectRegistrationItem={onConfigurationTabChange}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  selectedClient: state.cliente.ClienteSelecionado,
  selectedFarmId: state.fazenda.FazendaSelecionada,
  toggles: state.fazenda.Toggles,
});

const mapDispatchToProps = {
  fetchFarmCategories: fetchEnrichedFarmCategories,
  fetchFarmPastures: obtemPastosFazenda,
  onConfigurationTabChange: updateSelectedConfigurationTab,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigurationsContainer);
